// Shared constants and types for workflow/dashboard/report/research templates

export interface WorkflowTemplate {
  id: string;
  name: string;
  description: string | null;
  prompt_message: string;
  industries: string[];
  categories: string[];
  icon: string | null;
  is_active: boolean;
  template_type: "workflow" | "dashboard" | "report" | "research";
}

export const INDUSTRIES = [
  "Retail & E-Commerce",
  "Finance & Banking",
  "Insurance",
  "Travel & Hospitality",
  "Healthcare",
  "Logistics & Supply Chain",
  "SaaS & Technology",
  "Real Estate",
  "Education",
  "Media & Entertainment",
] as const;

export const TEMPLATE_CATEGORIES = [
  "Sales",
  "Marketing",
  "Customer Support",
  "Finance & Billing",
  "HR & People Ops",
  "Operations",
  "Analytics & Reporting",
  "Monitoring & Alerts",
  "Compliance & Security",
  "IT & DevOps",
  "Reviews & Reputation",
] as const;
